import SelectInput from '@/components/common/SelectInput';

const RecurrenceSelect = ({ ...props }) => {
    return (
        <SelectInput
            options={[
                { label: '/ week', value: { interval: 1, freq: 'WEEKLY' } },
                { label: '/ month', value: { interval: 1, freq: 'MONTHLY' } },
                { label: '/ quarter', value: { interval: 3, freq: 'MONTHLY' } },
            ]}
            {...props}
        />
    );
};

export default RecurrenceSelect;
